<template>
  <draggable
    :sort="business.canChangeStartingPoint ? true : false"
    v-bind="dragOptions"
    v-model="list"
  >
    <transition-group type="transition" name="flip-list">
      <v-row
        class="ml-3 item"
        v-for="(point, index) in list"
        :key="point.order"
      >
        <v-col cols="12" sm="2" md="2">
          <span class="position">{{ index + 1 }}</span></v-col
        >
        <v-col cols="12" sm="7" md="7"
          ><p class="black--text pa-0 ma-0">{{ point.address[0] }}</p>
          <small
            >{{ parseFloat(point.lat).toFixed(6) }},
            {{ parseFloat(point.lng).toFixed(6) }}</small
          >
        </v-col>
        <v-col cols="12" sm="3" md="3">
          <i
            @click="$emit('edit', { data: point, index: index + 1 })"
            class="fas fa-edit"
          ></i>
          <i @click="$emit('delete', index + 1)" class="fas fa-trash ml-3"></i>
        </v-col>
        <v-col cols="12" sm="12" md="12" class="pl-5">
          <p class="black--text">
            <b :class="{ 'error-tag': validation && !point.contactName }"
              >Contacto</b
            >:
            {{ point.contactName }}
          </p>
          <p class="black--text">
            <b :class="{ 'error-tag': validation && !point.contactPhone }"
              >Teléfono</b
            >:
            {{ point.contactPhone }}
          </p>
          <p class="black--text desc" style="text-align: justify">
            <b>Comentarios</b>: {{ point.comments }}
          </p>
        </v-col>
      </v-row>
    </transition-group>
  </draggable>
</template>

<script>
import draggable from "vuedraggable";

export default {
  name: "points",
  props: ["points", "business"],

  watch: {
    points() {
      this.items = Object.assign([], this.points);
    },
  },

  data() {
    return {
      items: [],
      selectedPoint: null,
      validation: false,
    };
  },

  computed: {
    list: {
      get() {
        return this.items.map((e, i) => {
          e.order = i;
          return e;
        });
      },
      set(value) {
        this.items = value;
        this.$emit("changed", this.items);
      },
    },
    dragOptions() {
      return {
        animation: 200,
        group: "description",
        disabled: false,
        ghostClass: "ghost",
      };
    },
  },
  components: {
    draggable,
  },
  mounted() {
    // console.log(this.business);
  },
};
</script>


<style scoped>
.fa-trash,
.fa-edit {
  color: rgba(128, 128, 128, 0.863);
  cursor: pointer;
}

.position {
  background-color: #FF1744;
  padding: 7px;
  border-radius: 30px;
  width: 30px;
  height: 30px;
  color: white;
  font-weight: bold;
  display: flex;
  justify-content: center;
  align-items: center;
}

.list-item {
  display: inline-block;
  /* margin-right: 10px; */
}
.list-enter-active,
.list-leave-active {
  transition: all 1s;
}
.list-enter, .list-leave-to /* .list-leave-active below version 2.1.8 */ {
  opacity: 0;
  transform: translateY(30px);
}

.flip-list-move {
  transition: transform 0.5s;
}

.ghost {
  opacity: 0.5;
  background: #c8ebfb;
}
/* 
.coor {
  font-size: 10px;
  color: #FF1744;
  padding: 0;
  margin: 0;
  text-align: start;
  margin-left: 10%;
}

p {
  text-align: start;
  margin-left: 10%;
  margin-top: 15px;
}

.error-tag {
  color: red;
}

.fade-enter-active {
  transition: opacity 0.5s;
}

.point-detail {
  font-size: 14px;
} */

.error-tag {
  color: red;
}

.item {
  /* background-color: #f7f7f7; */
  border-top: 0.5px solid rgba(147, 147, 147, 0.41);
}

.desc {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 4; /* number of lines to show */
  line-clamp: 2;
  -webkit-box-orient: vertical;
  padding-right: 20px;
}
</style>